module.exports = __webpack_public_path__ + "assets/img/046101.387006b4.svg";